import { EXCEPTION_TYPES } from '@onward-delivery/core';

export const REQUIRES_CARRIER_INSTRUCTION = [EXCEPTION_TYPES.DAMAGED, EXCEPTION_TYPES.REFUSAL, EXCEPTION_TYPES.OVERAGE];

export const INSTRUCTIONS = {
    RETURN_ITEMS: 'RETURN_ITEMS',
    SENDER_PICKUP: 'SENDER_PICKUP',
    DISPOSE_ITEMS: 'DISPOSE_ITEMS',
    NOOP: 'NOOP',
};

export const ACTIONS = {
    SPLIT_ORDERS: 'SPLIT_ORDERS',
    CREATE_EXCHANGE: 'CREATE_EXCHANGE',
    CREATE_RETURN: 'CREATE_RETURN',
    CREATE_WAREHOUSE_RETURN: 'CREATE_WAREHOUSE_RETURN',
    OMIT_ITEM: 'OMIT_ITEM',
    CANCEL_ORDER: 'CANCEL_ORDER',
    RESOLVE_NOOP: 'RESOLVE_NOOP',
    RESCHEDULE: 'RESCHEDULE',
    RESET_MARKETPLACE: 'RESET_MARKETPLACE',
    RESET_INTERNAL: 'RESET_INTERNAL',
    RETRY_EVENT: 'RETRY_EVENT',
    CHANGE_CARRIER: 'CHANGE_CARRIER',
    COMPLETE_ORDER: 'COMPLETE_ORDER',
};

export const INSTRUCTIONS_DISPLAY_MAPPING = {
    [INSTRUCTIONS.RETURN_ITEMS]: 'Return items',
    [INSTRUCTIONS.SENDER_PICKUP]: 'Sender will pick up items from customer',
    [INSTRUCTIONS.DISPOSE_ITEMS]: 'Donate/Dispose items',
    [INSTRUCTIONS.NOOP]: 'N/A',
};

export const ACTION_DISPLAY_MAPPING = {
    [ACTIONS.SPLIT_ORDERS]: 'Split and create a new order with affected items',
    [ACTIONS.CREATE_RETURN]: 'Create a normal return order',
    [ACTIONS.CREATE_WAREHOUSE_RETURN]: 'Create a warehouse return order',
    [ACTIONS.CREATE_EXCHANGE]: 'Create new order with items that need to be exchanged',
    [ACTIONS.OMIT_ITEM]: 'Omit items with issues and continue with order',
    [ACTIONS.CANCEL_ORDER]: 'Cancel order',
    [ACTIONS.RESOLVE_NOOP]: 'No resolution needed',
    [ACTIONS.RESCHEDULE]: 'Reschedule order',
    [ACTIONS.RESET_MARKETPLACE]: 'Return to marketplace',
    [ACTIONS.RETRY_EVENT]: 'Retry',
    [ACTIONS.CHANGE_CARRIER]: 'Select another carrier',
    [ACTIONS.COMPLETE_ORDER]: 'Mark order as complete',
};
